import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { timeModel } from '~/models';
import { getPayoutAccountingErrorMessage } from '~/utils/getAccountingInvoiceErrorMessage.utils';
export const payoutAccountingSectionTextsPath = 'payouts.accountingSection';
const accountingFullName = (accounting)=>getAccountingDetails(accounting).fullName;
export function getAccountingInfoStatus(payoutIntegration) {
    return payoutIntegration.accept({
        whenPendingSync: ()=>'pending',
        whenSynced: ()=>'success',
        whenSyncFailed: ()=>'error',
        whenSyncInProgress: ()=>'syncing',
        whenDeleted: ()=>'success'
    });
}
export function getCalloutIntent(status) {
    return status === 'error' ? 'error' : 'info';
}
export function getInfo(param) {
    let { payoutIntegration, accounting, accountingSectionTexts, accountingSyncErrorTexts } = param;
    return payoutIntegration.accept({
        whenPendingSync: ()=>accountingSectionTexts.readyToSync({
                accountingName: accountingFullName(accounting)
            }),
        whenSyncInProgress: ()=>accountingSectionTexts.syncInProgress(),
        whenSynced: ()=>null,
        whenSyncFailed: ()=>getPayoutAccountingErrorMessage({
                payoutIntegration,
                accounting,
                texts: accountingSyncErrorTexts
            }),
        whenDeleted: (param)=>{
            let { date } = param;
            return accountingSectionTexts.deletedOn({
                accountingName: accountingFullName(accounting),
                date: timeModel.formatDateWithTime(date)
            });
        }
    });
}
